var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.iframeLoaded) ? _c('div', {
    class: _vm.theme.confirmationPage
  }, [_c('v-card', [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "title"
    }
  }, [_vm._v("\n            При нажатии «Продолжить» вы продолжите работу во внешней системе для анализа кредитной истории.\n          ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "bold": ""
    }
  }, [_vm._v("\n            Анализ кредитной истории — за 5 минут превращает кредитную историю клиента в готовый план действий для\n            одобрения.\n          ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n            Вместо нескольких часов ручного анализа отчетов из разных бюро кредитной истории, поиска ошибок и\n            подготовки претензий — система автоматически:\n          ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('ul', [_c('li', [_vm._v("формирует сводный анализ;")]), _vm._v(" "), _c('li', [_vm._v("находит и классифицирует ошибки;")]), _vm._v(" "), _c('li', [_vm._v("показывает риски и рекомендации;")]), _vm._v(" "), _c('li', [_vm._v("готовит PDF-отчет и претензии в бюро кредитной истории.")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n            В результате вы экономите время, не пропускаете важные детали, повышаете конверсию в одобрение и можете\n            дополнительно монетизировать услугу анализа кредитной истории.\n          ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs": "5"
    }
  }, [_c('v-text', {
    attrs: {
      "type": "headline"
    }
  }, [_vm._v("Стоимость")])], 1)], 1), _vm._v(" "), _c('v-row', {
    directives: [{
      name: "margin",
      rawName: "v-margin.top",
      value: (3),
      expression: "3",
      modifiers: {
        "top": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.bottom",
      value: (3),
      expression: "3",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-col', {
    attrs: {
      "xs": "3"
    }
  }, [_c('div', [_c('tariff-card', {
    attrs: {
      "title": "Тариф Старт"
    }
  }, [_vm._v("\n                  390 ₽/шт\n                ")])], 1)]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "3"
    }
  }, [_c('div', [_c('tariff-card', {
    attrs: {
      "title": "Тариф Бизнес"
    }
  }, [_vm._v("\n                  295 ₽/шт (выгода 25%)\n                ")])], 1)]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "3"
    }
  }, [_c('div', [_c('tariff-card', {
    attrs: {
      "title": "Тариф Премиум"
    }
  }, [_vm._v("\n                  250 ₽/шт (выгода 35%)\n                ")])], 1)]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "3"
    }
  }, [_c('div', [_c('tariff-card', {
    attrs: {
      "title": "Тариф VIP"
    }
  }, [_vm._v("\n                  200 ₽/шт (выгода 50%)\n                ")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    class: _vm.theme.confirmationActions
  }, [_c('v-button', {
    attrs: {
      "primary": "",
      "large": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.confirmAndLoad
    }
  }, [_vm._v("\n            Продолжить\n          ")])], 1)])]), _vm._v(" "), _c('v-alert', {
    directives: [{
      name: "margin",
      rawName: "v-margin.top",
      value: (3),
      expression: "3",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "info": ""
    }
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (2),
      expression: "2"
    }]
  }, [_c('div', [_c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("Важно")])], 1), _vm._v(" "), _c('v-text', [_vm._v("Отчеты кредитной истории, сформированные ранее чем за 30 дней до текущей даты, не могут быть\n          обработаны.")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.top",
      value: (3),
      expression: "3",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n        Обработка загружаемых данных при использовании сервиса осуществляется ООО «ОПТИКАЛ» (ИНН: 4345537530).\n        При загрузке материалов в систему вы гарантируете наличие согласий субъектов персональных данных, необходимых\n        для законной обработки\n        персональных данных указанным лицом. Недостоверность указанной гарантии влечет ответственность в соответствии\n        с\n        "), _c('v-link', {
    attrs: {
      "to": "https://exbico.ru/oferta_und",
      "target": "_blank"
    }
  }, [_vm._v("\n          Лицензионное соглашение\n        ")]), _vm._v("\n        и законодательством.\n      ")], 1)], 1)], 1) : _c('refinance-analysis', {
    attrs: {
      "loading": _vm.loading,
      "error": _vm.error,
      "iframe-url": _vm.iframeUrl,
      "on-reload": _vm.handleReload,
      "theme": _vm.theme
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-783d475e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/refinanceAnalysis/RefinanceAnalysisContainer.vue
// module id = 1141
// module chunks = 0